import {roles} from "@/Enums";

const readCardsPolicy = [
  roles.Hauptbenutzer
];

const editCardsPolicy = [
  roles.Hauptbenutzer
];

export {
  readCardsPolicy,
  editCardsPolicy
}
